<!--
 * @Author: your name
 * @Date: 2020-09-10 15:36:28
 * @LastEditTime: 2022-10-31 14:51:09
 * @LastEditors: Please set LastEditors
 * @Description: 合同档案
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\contractInfo\contractAchrives\default.vue
-->
<template>
    <div class="contractAchrives-default">
        <van-nav-bar
            title=""
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        >
            <template #title>
                <van-tabs
                    v-model="activeIndex"
                    animated
                    @click="toggletab"
                >
                    <template v-for="(item,index) in navData">
                        <van-tab
                            :key="index"
                            :title="item.name"
                        >
                        </van-tab>
                    </template>
                </van-tabs>
            </template>
        </van-nav-bar>
        <section class="main-wrapper">
            <div class="box-wrapper">
                <component :is="currentView" :contract-number="contract_number" :contract-info="contractInfo"></component>
            </div>
        </section>
    </div>
</template>

<script>
import payedWays from './payedWays.vue';
import payedLog from './payedLog.vue';
import salesLog from './salesLog.vue';
export default {
    name: 'contract-achrives',
    components: {
        payedWays,
        payedLog,
        salesLog,
    },
    props: {},
    data() {
        return {
            currentView: 'payedWays',
            activeIndex: 0,
            navData: [
                {
                    name: '销售记录',
                    value: 'salesLog',
                },
            ],
            contract_number: '',
            contractInfo: {},
        };
    },
    watch: {},
    computed: {},
    created() {
        if (this.$store.state.versionMark === '2') {
            this.navData.unshift({
                name: '付款方式',
                value: 'payedWays',
            }, {
                name: '已付款',
                value: 'payedLog',
            },);
        }
    },
    mounted() {
        this.contract_number = this.$route.params.contract_number;
        this.handleContractInfo();
    },
    methods: {
        toggletab(index) {
            this.currentView = this.navData[index].value;
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 处理合同档案信息
        async handleContractInfo() {
            const res = await this.getContractInfo();
            if (res) {
                this.contractInfo = res;
                if (!this.contractInfo.contract_price_mark_num_list) {
                    this.contractInfo.contract_price_mark_num_list = [];
                }
                if (!this.contractInfo.contract_price_additional_list) {
                    this.contractInfo.contract_price_additional_list = [];
                }
            }
        },
        // 根据合同编号获取档案信息
        getContractInfo() {
            const path = '/interfaceApi/sale/contract_archives/get_contract_basic_info/' + this.contract_number;
            return this.$axios.$get(path, { defEx: true });
        },
    },
};
</script>
<style lang="stylus">
.contractAchrives-default
    width 100%
    height 100%
    display flex
    flex-direction column
    .van-nav-bar
        display flex
        .van-nav-bar__title
            max-width 100%
            .van-tabs
                .van-tabs__nav
                            background rgba(0,0,0,0)
                    .van-tab
                        flex-basis auto !important
                        font-size 14rpx
                        margin 0 6rpx
                        line-height 44rpx
                        color rgba(240,240,240,0.5)
                        transition 0.2s
                        &.van-tab--active
                            font-size 16rpx
                            line-height 44rpx
                            color #FFFFFF
                        .van-tab__text
                            white-space nowrap
                    .van-ellipsis
                        text-overflow initial
                    .van-tabs__line
                        display none
                .van-tabs__wrap
                    &:after
                        display none
        .van-ellipsis
            white-space normal
        .van-nav-bar__right
            width 0
    .main-wrapper
        flex 1
        overflow hidden
        .box-wrapper
            height 100%
            overflow-y auto
</style>